// extracted by mini-css-extract-plugin
export var equalColumn = "_cj-0";